import { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import AdminSidebar from '../../components/admin/AdminSidebar';
import AdminHeader from '../../components/admin/AdminHeader';
import UserTable from '../../components/admin/UserTable';
import Spinner from '../../components/Spinner';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  async function fetchUsers() {
    try {
      const usersRef = collection(db, 'users');
      const q = query(usersRef, orderBy('timestamp', 'desc'));
      const querySnap = await getDocs(q);
      
      const usersList = [];
      querySnap.forEach((doc) => {
        usersList.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      
      setUsers(usersList);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="flex">
      <AdminSidebar />
      <div className="flex-1 ml-64">
        <AdminHeader title="User Management" />
        
        <div className="p-6">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-gray-800">
              Total Users: {users.length}
            </h2>
            <p className="text-gray-600 mt-1">
              Admins: {users.filter((u) => u.role === 'admin' || u.isAdmin).length} • 
              Regular Users: {users.filter((u) => u.role !== 'admin' && !u.isAdmin).length}
            </p>
          </div>

          <UserTable users={users} onUpdate={fetchUsers} />
        </div>
      </div>
    </div>
  );
}
